import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const DataDetailsViewUpstreamDataQualityWarningsQueryGql: DocumentNode = gql`
query DataDetailsViewUpstreamDataQualityWarningsQuery($datasourceIds: [ID]! $first: Int!, $offset: Int!, $publishedConnectionsLineageEnabled: Boolean!) {
  embeddedDatasources (filter: {idWithin: $datasourceIds}){
    id
    upstreamDataQualityWarningsConnection (filter: {isActive: true},
                                           first: $first, offset: $offset,
                                          orderBy: {field: IS_SEVERE, direction: DESC}) {
      totalCount
      nodes {
        id
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
    }
  }
}

${DataQualityWarningFragmentGql}
${DataQualityWarningAssetFragmentGql}
`;
